import React from 'react';

// Runs once upon component loading - does not refresh
export function useUpdateMetaTags(newMetaTags: Partial<HTMLMetaElement>[]) {
    React.useEffect(() => {
        // Get existing meta tags
        const oldMetaTags = document.getElementsByTagName('meta');

        // Remove existing tags
        [...oldMetaTags].forEach((metaTag) => metaTag.parentElement.removeChild(metaTag));

        // Add meta tags
        newMetaTags.forEach((metaTagRecord) => {
            // Create meta tag element
            var meta = document.createElement('meta');

            // Update meta tag element
            meta.name = metaTagRecord.name;
            meta.content = metaTagRecord.content;

            // Append meta tag element
            document.getElementsByTagName('head')[0].appendChild(meta);
        });
    }, []);
}